export default __webpack_public_path__ + "static/media/ic_directory.4955f612.svg";